import React from "react";
import { Text } from "basis";
import {
  MONTHLY_FEES,
  FEES,
  RATES,
} from "../../../../components/Promotions/Description/constants";
import { currencyFormat } from "../../../../utils";
import { LessThanMinAmount } from "./LessThanMinAmount";
import {
  LOCATION,
  WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS,
} from "../../../../../assets/constants";

export const Minimum = ({ au, nz, order }) => {
  if (
    order?.location === LOCATION.WIDGET &&
    order?.price < WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS
  ) {
    return <LessThanMinAmount au={au} nz={nz} />;
  }

  const AU = () => (
    <>
      <Text align="center" margin="3 0">
      Pay your credit card minimum payment each month. Paying only the minimum monthly payment will not pay out the purchase before the end of the plan. At the end of the plan, interest will be charged at the Expired Plan Rate of {RATES["GEM_VISA_AU"]}% p.a..Monthly credit card fee of ${MONTHLY_FEES["AUD"]} per month applies (subject to change).
      </Text>
      <Text align="center" margin="3 0">
        New customers must apply &amp; be approved for a Latitude {order?.checkoutTemplate === 'HN' ? 'GO Mastercard' : 'Gem Visa credit card'}.
      </Text>
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" align="center">
        Lending criteria, T&C's and fees apply including a ${FEES["ESTABLISHMENT"]} establishment fee and ${FEES["GEM_VISA"]} annual fee (${FEES["GEM_VISA_HALF_YEARLY"]} half yearly). Standard interest rate (currently {RATES["GEM_VISA_NZ"]}% p.a.) applies after interest free term ends.
         Credit provided by Latitude Financial Services Limited.
      </Text>
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};